(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-how-to-make"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.htm-vid-wrapper').forEach(function(wrapper) {
      var video = wrapper.querySelector('video');
      var playBtn = wrapper.querySelector('.htm-vid-play');
      if (! video || ! playBtn) return;
      


// Only mute/unmute + fullscreen buttons; clicking the video pauses/resumes it.
      if (window.AvVideoControls) {
        window.AvVideoControls.attach(wrapper, video, {clickToggle: true});
      }

      var play = function() {
        wrapper.classList.add('is-playing');
        if (window.AvVideoControls) {
          window.AvVideoControls.play(video);
        } else {
          video.play();
        }
      };

      playBtn.addEventListener('click', play);
      video.addEventListener('play', function() {
        wrapper.classList.add('is-playing');
      });
      video.addEventListener('pause', function() {
        wrapper.classList.remove('is-playing');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
